import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import trailerTypeSlice, { TrailerType } from "./slice";

type TrailerTypeResponse = ApiResponse<{ data: TrailerType[] }>;

function* trailerTypeSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetch);
}

function* handleFetch() {
  const response: TrailerTypeResponse = yield call(fetchAPI, "/trailer-types");

  if (response && response.data) {
    yield put(trailerTypeSlice.actions.setData(response.data));
  }

  yield put(trailerTypeSlice.actions.setIsLoading(false));
}

export default trailerTypeSaga;
